import { TOAST_TYPE } from "../../constants";
import { CUSTOMER_REPORT_ROUTES } from "../../constants/customerApiRoutes";
import { showToastMessage } from "../../utils";
import API from "../axios";

export const createCustomerReport = async (
  data: any,
  handleLoading: CallableFunction,
  handleCallback: CallableFunction
) => {
  try {
    const response = await API.post(CUSTOMER_REPORT_ROUTES.ADD_REPORT, data);
    showToastMessage(TOAST_TYPE.SUCCESS, response.data.message);
    handleCallback();
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  } finally {
    handleLoading(false);
  }
};
